import { useEffect, useState } from "react";
import { X } from "lucide-react";

const PROMO_CODE = "LIFETIME20";
const STORAGE_KEY = "sf_promo_code";
const DISMISS_KEY = "sf_promo_banner_dismissed";

export const PromoBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Always persist the promo so checkout applies it, even if banner is dismissed
    try {
      localStorage.setItem(STORAGE_KEY, PROMO_CODE);
    } catch {}
    const dismissed = (() => {
      try {
        return localStorage.getItem(DISMISS_KEY) === "1";
      } catch {
        return false;
      }
    })();
    if (!dismissed) setVisible(true);
  }, []);

  if (!visible) return null;

  return (
    <div className="relative z-40 bg-black text-white">
      <div className="container mx-auto px-3 lg:px-8 py-2 sm:py-2.5 flex items-center justify-center gap-2 sm:gap-3 text-center">
        <p className="text-[12px] sm:text-sm font-semibold leading-tight uppercase !text-white" style={{ color: "#ffffff" }}>
          <span className="hidden sm:inline">This month only: </span>
          20% off for life with code{" "}
          <span className="inline-block bg-white text-black rounded-full px-2 py-0.5 font-extrabold tracking-wide">
            {PROMO_CODE}
          </span>
          <span className="hidden sm:inline"> — auto-applied at checkout</span>
        </p>
        <button
          type="button"
          aria-label="Dismiss promotion"
          onClick={() => {
            try {
              localStorage.setItem(DISMISS_KEY, "1");
            } catch {}
            setVisible(false);
          }}
          className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 h-7 w-7 sm:h-8 sm:w-8 inline-flex items-center justify-center rounded-full hover:bg-white/15 transition"
        >
          <X className="h-3.5 w-3.5 sm:h-4 sm:w-4" />
        </button>
      </div>
    </div>
  );
};
